import './style.scss';

import React from 'react';

const Container = props => {
  let classList = ['card'];
  if (props.block) classList.push('card--block');
  if (props.className) classList.push(props.className);

  return <div className={classList.join(' ')}>{props.children}</div>;
};

const Image = props => {
  let classList = ['card__image'];
  if (props.className) classList.push(props.className);

  return <div className={classList.join(' ')} />;
};

const Text = props => {
  return <div className="card__text">{props.children}</div>;
};

export default Container;
export { Container, Image, Text };



// WEBPACK FOOTER //
// ./shared/components/ui/card/index.js